import { Link } from "react-router-dom";
import styled from "styled-components";

import { Badge } from "@olist/design-system";

export const CustomLink = styled(Link)`
  color: ${({ theme }) => theme.olist.color.primary.base};
  margin-bottom: 8px;

  transition: filter 0.2s ease-in-out;

  &:hover {
    filter: brightness(200%);
  }
`;

export const CustomBadge = styled(Badge)`
  margin-left: 8px;
`;
